// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".appvue." + {"23":"dcc9e0f3","40":"097ac642","50":"e5debd6a","98":"3335705f","210":"3afb47fe","472":"a31b2d55","881":"17f108e3"}[chunkId] + ".js";
};